import { render, staticRenderFns } from "./LmAdminMenuBuilder.vue?vue&type=template&id=5aa8bb12"
import script from "./LmAdminMenuBuilder.vue?vue&type=script&lang=js"
export * from "./LmAdminMenuBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports